import { Pills } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import { ON_COLOR_PILL } from '@/components/objectives/objectiveStyles';
import {
    PILLAR_STATUS_LABEL_KEY,
    PILLAR_STATUS_PILL,
} from '@/components/VisionValues/pillarStatusDisplay';
import { PillarStatus, type PillarStatusType } from '@/constants/PillarStatus';

interface PillarStatusMentionProps {
    status: PillarStatusType;
    /** `onColor` sits on a pillar's own gradient tile, where the library's light pill would stand out. */
    tone?: 'light' | 'onColor';
    dataTestId?: string;
}

/**
 * Marks a pillar that is not active -- a draft not yet published, or a retired pillar -- wherever it
 * is still shown, with the status the pillar settings give it. Renders nothing for an active pillar.
 */
export default function PillarStatusMention({
    status,
    tone = 'light',
    dataTestId,
}: PillarStatusMentionProps) {
    const { t } = useTranslation();

    if (status === PillarStatus.ACTIVE) {
        return null;
    }

    const label = t(PILLAR_STATUS_LABEL_KEY[status]);

    if (tone === 'onColor') {
        return (
            <span
                className={ON_COLOR_PILL}
                data-testid={dataTestId}
            >
                {label}
            </span>
        );
    }

    return (
        <Pills
            variant={PILLAR_STATUS_PILL[status].variant}
            status={PILLAR_STATUS_PILL[status].status}
            size={'xs'}
            dataTestId={dataTestId}
        >
            {label}
        </Pills>
    );
}
